var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Paper',{staticClass:"desc-module-root p-5"},[_c('div',{staticClass:"post-description"},[(_vm.isLoading)?_c('div',[_c('PresentationSkeleton')],1):_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }